module.exports = __webpack_public_path__ + "img/14.f04360ec.png";